import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { IsLoadingModule } from '@service-work/is-loading';
import { CommonService } from 'src/app/shared/services/common.service';
import { ImageLightboxDialogComponent } from './dialog/image-lightbox-dialog/image-lightbox-dialog.component';
import { ResidenceHistoryDialogComponent } from './dialog/residence-history-dialog/residence-history-dialog.component';
import { SelectActionComponent } from './dialog/select-action/select-action.component';
import { NumberOnlyDirective } from './directives/number-only/number-only.directive';
import { DocumentExtractApiService } from './services/document-extract-api.service';
import { DocumentExtractDataService } from './services/document-extract-data.service';
import { DocumentExtractSchemaService } from './services/document-extract-schema.service';
import { DriverApiService } from './services/driver-api.service';
import { FleetoperateApiService } from './services/fleetoperate-api.service';

@NgModule({
  imports: [IsLoadingModule, CommonModule, MatIconModule, MatButtonModule, MatDialogModule, ResidenceHistoryDialogComponent],
  declarations: [NumberOnlyDirective, SelectActionComponent, ImageLightboxDialogComponent],
  providers: [
    DriverApiService,
    FleetoperateApiService,
    CommonService,
    DocumentExtractApiService,
    DocumentExtractDataService,
    DocumentExtractSchemaService
  ],
  exports: [NumberOnlyDirective]
})
export class SharedModule { }

